import { Table, Input, Space, Button } from "antd";
import { formatDateAndTime } from "../../Common/Utils";
import { BarChartOutlined, SearchOutlined } from "@ant-design/icons";

const DeviationMonitorTable = ({
  filterDetails,
  setFilterDetails,
  metaData,
  handleOpen,
}) => {
  const handlePageChange = (pagination, filters) => {
    setFilterDetails((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
      ...filters,
    }));
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => {
      const onResetSearch = async () => {
        await clearFilters();
        await confirm();
      };
      return (
        <div
          className="filter-dropdown-card"
          data-testid="filter-dropdown"
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            allowClear
            data-testid={dataIndex + "-search-input"}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={confirm}
            style={{
              width: "250px",
              marginBottom: 8,
            }}
          />
          <Space>
            <Button
              type="link"
              size="small"
              data-testid="search-filter-close-btn"
              onClick={close}
            >
              close
            </Button>
            <Button
              onClick={onResetSearch}
              size="small"
              data-testid="search-filter-reset-btn"
              className="table-filter-btn"
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={confirm}
              icon={<SearchOutlined />}
              size="small"
              className="table-filter-btn"
            >
              Search
            </Button>
          </Space>
        </div>
      );
    },
    filterIcon: (filtered) => (
      <SearchOutlined
        data-testid={dataIndex + "-search-icon"}
        style={{
          color: filtered ? "#1677ff" : undefined,
          fontSize: "16px",
        }}
      />
    ),
  });

  const columns = [
    {
      title: "IMEI",
      dataIndex: "imei",
      key: "imei",
      align: "center",
      ...getColumnSearchProps("imei"),
    },
    {
      title: "Part Name",
      dataIndex: "partName",
      key: "partName",
      align: "left",
      className: "pl1",
      ...getColumnSearchProps("partName"),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      align: "left",
      className: "pl1 display-flex",
      render: (category) => (
        <div className={category + "-card"}>{category?.toUpperCase()}</div>
      ),
    },
    {
      title: "Metric",
      dataIndex: "metric",
      key: "metric",
      align: "left",
      className: "pl1",
      ...getColumnSearchProps("metric"),
    },
    {
      title: "Threshold",
      dataIndex: "threshold",
      key: "threshold",
      align: "center",
      render: (threshold) => threshold?.toUpperCase(),
    },
    {
      title: "Current Value",
      dataIndex: "currentValue",
      key: "currentValue",
      align: "center",
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      align: "center",
      render: (timestamp) => <span>{formatDateAndTime(timestamp)}</span>,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <BarChartOutlined
          onClick={() => handleOpen(record)}
          data-testid="alert-graph-icon"
        />
      ),
    },
  ];

  return (
    <>
      <Table
        data-testid="deviation-monitor-alert-list"
        columns={columns}
        className={"deviation-monitor-vehicle-table " + filterDetails?.category}
        dataSource={metaData?.content}
        rowKey={(record) => record.id}
        scroll={{ x: "100%" }}
        onChange={handlePageChange}
        pagination={{
          current: filterDetails.current,
          pageSize: filterDetails.pageSize,
          total: metaData?.totalElements,
          showSizeChanger: false,
          showQuickJumper: false,
          hideOnSinglePage: true,
        }}
      />
    </>
  );
};
export default DeviationMonitorTable;
